import { Box, Flex } from '@chakra-ui/react';
import { Text } from 'components/ui';

// A fixed pair, the same one the mobile app shows on its own initial
// consultation scheduler. The providers for the chosen slot are not used here.
const AVATARS = [
  { alt: 'Ayble physician', src: '/headshots/physician.png' },
  { alt: 'Ayble coach', src: '/headshots/coach.png' },
];

type Props = {
  description: string;
  duration: string;
  title: string;
};

export const VisitHeader = ({ description, duration, title }: Props) => (
  <Flex direction={'column'} gap={'10px'} w={'100%'}>
    <Flex alignItems={'center'} gap={'13px'} w={'100%'}>
      <Flex flexShrink={0}>
        {AVATARS.map(({ alt, src }, index) => (
          <Box
            borderColor={'white'}
            borderWidth={'3px'}
            h={'44px'}
            key={src}
            ml={index ? '-12px' : 0}
            overflow={'hidden'}
            rounded={'pill'}
            w={'44px'}
          >
            <img
              alt={alt}
              src={src}
              style={{
                display: 'block',
                height: '100%',
                objectFit: 'cover',
                width: '100%',
              }}
            />
          </Box>
        ))}
      </Flex>

      <Box>
        <Text
          as={'span'}
          color={'secondary.500'}
          fontSize={'17px'}
          fontWeight={700}
        >
          {title}
        </Text>{' '}
        <Text as={'span'} color={'blueGray.600'} fontSize={'17px'}>
          {duration}
        </Text>
      </Box>
    </Flex>

    <Text color={'blueGray.600'} fontSize={'13px'} lineHeight={'1.5'}>
      {description}
    </Text>
  </Flex>
);
